import type { Directive } from 'vue'
import { generateDataLhId } from '@/utils/data-lh-id'
import type { DataLhIdModule } from '@/utils/data-lh-id/types'

const dataLhIdDirective: Directive = {
  mounted (el, binding) {
    if (binding.value) {
      el.dataset.lhId = generateDataLhId(binding.value as DataLhIdModule.DataLhIdParams)
    }
  },
  updated (el, binding) {
    if (binding.value) {
      el.dataset.lhId = generateDataLhId(binding.value as DataLhIdModule.DataLhIdParams)
    }
  }
}

export default dataLhIdDirective
